export const RESET_MESSAGE = 'RESET_MESSAGE';

export const LOGIN_PROGRESS = "LOGIN_PROGRESS";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const LOGOUT_PROGRESS = "LOGOUT_PROGRESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

export const GET_STATES_LIST_PROGRESS = "GET_STATES_LIST_PROGRESS";
export const GET_STATES_LIST_SUCCESS = "GET_STATES_LIST_SUCCESS";
export const GET_STATES_LIST_FAILURE = "GET_STATES_LIST_FAILURE";

export const GET_BANK_LIST_PROGRESS = "GET_BANK_LIST_PROGRESS";
export const GET_BANK_LIST_SUCCESS = "GET_BANK_LIST_SUCCESS";
export const GET_BANK_LIST_FAILURE = "GET_BANK_LIST_FAILURE";

export const ADD_BANK_PROGRESS = "ADD_BANK_PROGRESS";
export const ADD_BANK_SUCCESS = "ADD_BANK_SUCCESS";
export const ADD_BANK_FAILURE = "ADD_BANK_FAILURE";

export const EDIT_DELETE_BANK_PROGRESS = "EDIT_DELETE_BANK_PROGRESS";
export const EDIT_DELETE_BANK_SUCCESS = "EDIT_DELETE_BANK_SUCCESS";
export const EDIT_DELETE_BANK_FAILURE = "EDIT_DELETE_BANK_FAILURE";

export const GET_STORE_LIST_PROGRESS = "GET_STORE_LIST_PROGRESS";
export const GET_STORE_LIST_SUCCESS = "GET_STORE_LIST_SUCCESS";
export const GET_STORE_LIST_FAILURE = "GET_STORE_LIST_FAILURE";

export const ADD_STORE_PROGRESS = "ADD_STORE_PROGRESS";
export const ADD_STORE_SUCCESS = "ADD_STORE_SUCCESS";
export const ADD_STORE_FAILURE = "ADD_STORE_FAILURE";

export const EDIT_DELETE_STORE_PROGRESS = "EDIT_DELETE_STORE_PROGRESS";
export const EDIT_DELETE_STORE_SUCCESS = "EDIT_DELETE_STORE_SUCCESS";
export const EDIT_DELETE_STORE_FAILURE = "EDIT_DELETE_STORE_FAILURE";

export const GET_UNIT_LIST_PROGRESS = "GET_UNIT_LIST_PROGRESS";
export const GET_UNIT_LIST_SUCCESS = "GET_UNIT_LIST_SUCCESS";
export const GET_UNIT_LIST_FAILURE = "GET_UNIT_LIST_FAILURE";

export const ADD_UNIT_PROGRESS = "ADD_UNIT_PROGRESS";
export const ADD_UNIT_SUCCESS = "ADD_UNIT_SUCCESS";
export const ADD_UNIT_FAILURE = "ADD_UNIT_FAILURE";

export const EDIT_DELETE_UNIT_PROGRESS = "EDIT_DELETE_UNIT_PROGRESS";
export const EDIT_DELETE_UNIT_SUCCESS = "EDIT_DELETE_UNIT_SUCCESS";
export const EDIT_DELETE_UNIT_FAILURE = "EDIT_DELETE_UNIT_FAILURE";

export const GET_BIN_LIST_PROGRESS = "GET_BIN_LIST_PROGRESS";
export const GET_BIN_LIST_SUCCESS = "GET_BIN_LIST_SUCCESS";
export const GET_BIN_LIST_FAILURE = "GET_BIN_LIST_FAILURE";

export const ADD_BIN_PROGRESS = "ADD_BIN_PROGRESS";
export const ADD_BIN_SUCCESS = "ADD_BIN_SUCCESS";
export const ADD_BIN_FAILURE = "ADD_BIN_FAILURE";

export const EDIT_DELETE_BIN_PROGRESS = "EDIT_DELETE_BIN_PROGRESS";
export const EDIT_DELETE_BIN_SUCCESS = "EDIT_DELETE_BIN_SUCCESS";
export const EDIT_DELETE_BIN_FAILURE = "EDIT_DELETE_BIN_FAILURE";

export const GET_REJECT_LIST_PROGRESS = "GET_REJECT_LIST_PROGRESS";
export const GET_REJECT_LIST_SUCCESS = "GET_REJECT_LIST_SUCCESS";
export const GET_REJECT_LIST_FAILURE = "GET_REJECT_LIST_FAILURE";

export const ADD_REJECT_PROGRESS = "ADD_REJECT_PROGRESS";
export const ADD_REJECT_SUCCESS = "ADD_REJECT_SUCCESS";
export const ADD_REJECT_FAILURE = "ADD_REJECT_FAILURE";

export const EDIT_DELETE_REJECT_PROGRESS = "EDIT_DELETE_REJECT_PROGRESS";
export const EDIT_DELETE_REJECT_SUCCESS = "EDIT_DELETE_REJECT_SUCCESS";
export const EDIT_DELETE_REJECT_FAILURE = "EDIT_DELETE_REJECT_FAILURE";

export const GET_ITEM_LIST_PROGRESS = "GET_ITEM_LIST_PROGRESS";
export const GET_ITEM_LIST_SUCCESS = "GET_ITEM_LIST_SUCCESS";
export const GET_ITEM_LIST_FAILURE = "GET_ITEM_LIST_FAILURE";

export const ADD_ITEM_PROGRESS = "ADD_ITEM_PROGRESS";
export const ADD_ITEM_SUCCESS = "ADD_ITEM_SUCCESS";
export const ADD_ITEM_FAILURE = "ADD_ITEM_FAILURE";

export const EDIT_DELETE_ITEM_PROGRESS = "EDIT_DELETE_ITEM_PROGRESS";
export const EDIT_DELETE_ITEM_SUCCESS = "EDIT_DELETE_ITEM_SUCCESS";
export const EDIT_DELETE_ITEM_FAILURE = "EDIT_DELETE_ITEM_FAILURE";

export const GET_ACCOUNT_MANAGER_LIST_PROGRESS = "GET_ACCOUNT_MANAGER_LIST_PROGRESS";
export const GET_ACCOUNT_MANAGER_LIST_SUCCESS = "GET_ACCOUNT_MANAGER_LIST_SUCCESS";
export const GET_ACCOUNT_MANAGER_LIST_FAILURE = "GET_ACCOUNT_MANAGER_LIST_FAILURE";

export const ADD_ACCOUNT_MANAGER_PROGRESS = "ADD_ACCOUNT_MANAGER_PROGRESS";
export const ADD_ACCOUNT_MANAGER_SUCCESS = "ADD_ACCOUNT_MANAGER_SUCCESS";
export const ADD_ACCOUNT_MANAGER_FAILURE = "ADD_ACCOUNT_MANAGER_FAILURE";

export const EDIT_DELETE_ACCOUNT_MANAGER_PROGRESS = "EDIT_DELETE_ACCOUNT_MANAGER_PROGRESS";
export const EDIT_DELETE_ACCOUNT_MANAGER_SUCCESS = "EDIT_DELETE_ACCOUNT_MANAGER_SUCCESS";
export const EDIT_DELETE_ACCOUNT_MANAGER_FAILURE = "EDIT_DELETE_ACCOUNT_MANAGER_FAILURE";

export const GET_TERMS_CONDITIONS_LIST_PROGRESS = "GET_TERMS_CONDITIONS_LIST_PROGRESS";
export const GET_TERMS_CONDITIONS_LIST_SUCCESS = "GET_TERMS_CONDITIONS_LIST_SUCCESS";
export const GET_TERMS_CONDITIONS_LIST_FAILURE = "GET_TERMS_CONDITIONS_LIST_FAILURE";

export const ADD_TERMS_CONDITIONS_PROGRESS = "ADD_TERMS_CONDITIONS_PROGRESS";
export const ADD_TERMS_CONDITIONS_SUCCESS = "ADD_TERMS_CONDITIONS_SUCCESS";
export const ADD_TERMS_CONDITIONS_FAILURE = "ADD_TERMS_CONDITIONS_FAILURE";

export const EDIT_DELETE_TERMS_CONDITIONS_PROGRESS = "EDIT_DELETE_TERMS_CONDITIONS_PROGRESS";
export const EDIT_DELETE_TERMS_CONDITIONS_SUCCESS = "EDIT_DELETE_TERMS_CONDITIONS_SUCCESS";
export const EDIT_DELETE_TERMS_CONDITIONS_FAILURE = "EDIT_DELETE_TERMS_CONDITIONS_FAILURE";

export const GET_CATEGORY_LIST_PROGRESS = "GET_CATEGORY_LIST_PROGRESS";
export const GET_CATEGORY_LIST_SUCCESS = "GET_CATEGORY_LIST_SUCCESS";
export const GET_CATEGORY_LIST_FAILURE = "GET_CATEGORY_LIST_FAILURE";

export const ADD_CATEGORY_PROGRESS = "ADD_CATEGORY_PROGRESS";
export const ADD_CATEGORY_SUCCESS = "ADD_CATEGORY_SUCCESS";
export const ADD_CATEGORY_FAILURE = "ADD_CATEGORY_FAILURE";

export const EDIT_DELETE_CATEGORY_PROGRESS = "EDIT_DELETE_CATEGORY_PROGRESS";
export const EDIT_DELETE_CATEGORY_SUCCESS = "EDIT_DELETE_CATEGORY_SUCCESS";
export const EDIT_DELETE_CATEGORY_FAILURE = "EDIT_DELETE_CATEGORY_FAILURE";

export const GET_CUSTOMER_LIST_PROGRESS = "GET_CUSTOMER_LIST_PROGRESS";
export const GET_CUSTOMER_LIST_SUCCESS = "GET_CUSTOMER_LIST_SUCCESS";
export const GET_CUSTOMER_LIST_FAILURE = "GET_CUSTOMER_LIST_FAILURE";

export const ADD_CUSTOMER_PROGRESS = "ADD_CUSTOMER_PROGRESS";
export const ADD_CUSTOMER_SUCCESS = "ADD_CUSTOMER_SUCCESS";
export const ADD_CUSTOMER_FAILURE = "ADD_CUSTOMER_FAILURE";

export const EDIT_DELETE_CUSTOMER_PROGRESS = "EDIT_DELETE_CUSTOMER_PROGRESS";
export const EDIT_DELETE_CUSTOMER_SUCCESS = "EDIT_DELETE_CUSTOMER_SUCCESS";
export const EDIT_DELETE_CUSTOMER_FAILURE = "EDIT_DELETE_CUSTOMER_FAILURE";

export const GET_SUPPLIER_LIST_PROGRESS = "GET_SUPPLIER_LIST_PROGRESS";
export const GET_SUPPLIER_LIST_SUCCESS = "GET_SUPPLIER_LIST_SUCCESS";
export const GET_SUPPLIER_LIST_FAILURE = "GET_SUPPLIER_LIST_FAILURE";

export const ADD_SUPPLIER_PROGRESS = "ADD_SUPPLIER_PROGRESS";
export const ADD_SUPPLIER_SUCCESS = "ADD_SUPPLIER_SUCCESS";
export const ADD_SUPPLIER_FAILURE = "ADD_SUPPLIER_FAILURE";

export const EDIT_DELETE_SUPPLIER_PROGRESS = "EDIT_DELETE_SUPPLIER_PROGRESS";
export const EDIT_DELETE_SUPPLIER_SUCCESS = "EDIT_DELETE_SUPPLIER_SUCCESS";
export const EDIT_DELETE_SUPPLIER_FAILURE = "EDIT_DELETE_SUPPLIER_FAILURE";

export const GET_CNS_LIST_PROGRESS = "GET_CNS_LIST_PROGRESS";
export const GET_CNS_LIST_SUCCESS = "GET_CNS_LIST_SUCCESS";
export const GET_CNS_LIST_FAILURE = "GET_CNS_LIST_FAILURE";

export const ADD_CNS_PROGRESS = "ADD_CNS_PROGRESS";
export const ADD_CNS_SUCCESS = "ADD_CNS_SUCCESS";
export const ADD_CNS_FAILURE = "ADD_CNS_FAILURE";

export const EDIT_DELETE_CNS_PROGRESS = "EDIT_DELETE_CNS_PROGRESS";
export const EDIT_DELETE_CNS_SUCCESS = "EDIT_DELETE_CNS_SUCCESS";
export const EDIT_DELETE_CNS_FAILURE = "EDIT_DELETE_CNS_FAILURE";

// ========================= Settings ============================

export const GET_COMPANY_DETAILS_LIST_PROGRESS = "GET_COMPANY_DETAILS_LIST_PROGRESS";
export const GET_COMPANY_DETAILS_LIST_SUCCESS = "GET_COMPANY_DETAILS_LIST_SUCCESS";
export const GET_COMPANY_DETAILS_LIST_FAILURE = "GET_COMPANY_DETAILS_LIST_FAILURE";

export const ADD_COMPANY_DETAILS_PROGRESS = "ADD_COMPANY_DETAILS_PROGRESS";
export const ADD_COMPANY_DETAILS_SUCCESS = "ADD_COMPANY_DETAILS_SUCCESS";
export const ADD_COMPANY_DETAILS_FAILURE = "ADD_COMPANY_DETAILS_FAILURE";

export const EDIT_DELETE_COMPANY_DETAILS_PROGRESS = "EDIT_DELETE_COMPANY_DETAILS_PROGRESS";
export const EDIT_DELETE_COMPANY_DETAILS_SUCCESS = "EDIT_DELETE_COMPANY_DETAILS_SUCCESS";
export const EDIT_DELETE_COMPANY_DETAILS_FAILURE = "EDIT_DELETE_COMPANY_DETAILS_FAILURE";

export const GET_DOC_NO_FORMATE_LIST_PROGRESS = "GET_DOC_NO_FORMATE_LIST_PROGRESS";
export const GET_DOC_NO_FORMATE_LIST_SUCCESS = "GET_DOC_NO_FORMATE_LIST_SUCCESS";
export const GET_DOC_NO_FORMATE_LIST_FAILURE = "GET_DOC_NO_FORMATE_LIST_FAILURE";

export const ADD_DOC_NO_FORMATE_PROGRESS = "ADD_DOC_NO_FORMATE_PROGRESS";
export const ADD_DOC_NO_FORMATE_SUCCESS = "ADD_DOC_NO_FORMATE_SUCCESS";
export const ADD_DOC_NO_FORMATE_FAILURE = "ADD_DOC_NO_FORMATE_FAILURE";

export const EDIT_DELETE_DOC_NO_FORMATE_PROGRESS = "EDIT_DELETE_DOC_NO_FORMATE_PROGRESS";
export const EDIT_DELETE_DOC_NO_FORMATE_SUCCESS = "EDIT_DELETE_DOC_NO_FORMATE_SUCCESS";
export const EDIT_DELETE_DOC_NO_FORMATE_FAILURE = "EDIT_DELETE_DOC_NO_FORMATE_FAILURE";

export const GET_DOC_NO_FORMATE_AVAILABLE_PROGRESS = "GET_DOC_NO_FORMATE_AVAILABLE_PROGRESS";
export const GET_DOC_NO_FORMATE_AVAILABLE_SUCCESS = "GET_DOC_NO_FORMATE_AVAILABLE_SUCCESS";
export const GET_DOC_NO_FORMATE_AVAILABLE_FAILURE = "GET_DOC_NO_FORMATE_AVAILABLE_FAILURE";

export const GET_INVOICE_SETTING_LIST_PROGRESS = "GET_INVOICE_SETTING_LIST_PROGRESS";
export const GET_INVOICE_SETTING_LIST_SUCCESS = "GET_INVOICE_SETTING_LIST_SUCCESS";
export const GET_INVOICE_SETTING_LIST_FAILURE = "GET_INVOICE_SETTING_LIST_FAILURE";

export const ADD_INVOICE_SETTING_PROGRESS = "ADD_INVOICE_SETTING_PROGRESS";
export const ADD_INVOICE_SETTING_SUCCESS = "ADD_INVOICE_SETTING_SUCCESS";
export const ADD_INVOICE_SETTING_FAILURE = "ADD_INVOICE_SETTING_FAILURE";

export const EDIT_DELETE_INVOICE_SETTING_PROGRESS = "EDIT_DELETE_INVOICE_SETTING_PROGRESS";
export const EDIT_DELETE_INVOICE_SETTING_SUCCESS = "EDIT_DELETE_INVOICE_SETTING_SUCCESS";
export const EDIT_DELETE_INVOICE_SETTING_FAILURE = "EDIT_DELETE_INVOICE_SETTING_FAILURE";

export const GET_MENU_SETTING_LIST_PROGRESS = "GET_MENU_SETTING_LIST_PROGRESS";
export const GET_MENU_SETTING_LIST_SUCCESS = "GET_MENU_SETTING_LIST_SUCCESS";
export const GET_MENU_SETTING_LIST_FAILURE = "GET_MENU_SETTING_LIST_FAILURE";

export const ADD_MENU_SETTING_PROGRESS = "ADD_MENU_SETTING_PROGRESS";
export const ADD_MENU_SETTING_SUCCESS = "ADD_MENU_SETTING_SUCCESS";
export const ADD_MENU_SETTING_FAILURE = "ADD_MENU_SETTING_FAILURE";

export const EDIT_DELETE_MENU_SETTING_PROGRESS = "EDIT_DELETE_MENU_SETTING_PROGRESS";
export const EDIT_DELETE_MENU_SETTING_SUCCESS = "EDIT_DELETE_MENU_SETTING_SUCCESS";
export const EDIT_DELETE_MENU_SETTING_FAILURE = "EDIT_DELETE_MENU_SETTING_FAILURE";

export const GET_INVOICE_TITLE_LIST_PROGRESS = "GET_INVOICE_TITLE_LIST_PROGRESS";
export const GET_INVOICE_TITLE_LIST_SUCCESS = "GET_INVOICE_TITLE_LIST_SUCCESS";
export const GET_INVOICE_TITLE_LIST_FAILURE = "GET_INVOICE_TITLE_LIST_FAILURE";

export const ADD_INVOICE_TITLE_PROGRESS = "ADD_INVOICE_TITLE_PROGRESS";
export const ADD_INVOICE_TITLE_SUCCESS = "ADD_INVOICE_TITLE_SUCCESS";
export const ADD_INVOICE_TITLE_FAILURE = "ADD_INVOICE_TITLE_FAILURE";

export const EDIT_DELETE_INVOICE_TITLE_PROGRESS = "EDIT_DELETE_INVOICE_TITLE_PROGRESS";
export const EDIT_DELETE_INVOICE_TITLE_SUCCESS = "EDIT_DELETE_INVOICE_TITLE_SUCCESS";
export const EDIT_DELETE_INVOICE_TITLE_FAILURE = "EDIT_DELETE_INVOICE_TITLE_FAILURE";

export const GET_PURCHASE_SETTING_LIST_PROGRESS = "GET_PURCHASE_SETTING_LIST_PROGRESS";
export const GET_PURCHASE_SETTING_LIST_SUCCESS = "GET_PURCHASE_SETTING_LIST_SUCCESS";
export const GET_PURCHASE_SETTING_LIST_FAILURE = "GET_PURCHASE_SETTING_LIST_FAILURE";

export const ADD_PURCHASE_SETTING_PROGRESS = "ADD_PURCHASE_SETTING_PROGRESS";
export const ADD_PURCHASE_SETTING_SUCCESS = "ADD_PURCHASE_SETTING_SUCCESS";
export const ADD_PURCHASE_SETTING_FAILURE = "ADD_PURCHASE_SETTING_FAILURE";

export const EDIT_DELETE_PURCHASE_SETTING_PROGRESS = "EDIT_DELETE_PURCHASE_SETTING_PROGRESS";
export const EDIT_DELETE_PURCHASE_SETTING_SUCCESS = "EDIT_DELETE_PURCHASE_SETTING_SUCCESS";
export const EDIT_DELETE_PURCHASE_SETTING_FAILURE = "EDIT_DELETE_PURCHASE_SETTING_FAILURE";

export const GET_ALL_USER_MANAGEMENT_LIST_PROGRESS = "GET_ALL_USER_MANAGEMENT_LIST_PROGRESS";
export const GET_ALL_USER_MANAGEMENT_LIST_SUCCESS = "GET_ALL_USER_MANAGEMENT_LIST_SUCCESS";
export const GET_ALL_USER_MANAGEMENT_LIST_FAILURE = "GET_ALL_USER_MANAGEMENT_LIST_FAILURE";

export const GET_USER_MANAGEMENT_LIST_PROGRESS = "GET_USER_MANAGEMENT_LIST_PROGRESS";
export const GET_USER_MANAGEMENT_LIST_SUCCESS = "GET_USER_MANAGEMENT_LIST_SUCCESS";
export const GET_USER_MANAGEMENT_LIST_FAILURE = "GET_USER_MANAGEMENT_LIST_FAILURE";

export const ADD_USER_MANAGEMENT_PROGRESS = "ADD_USER_MANAGEMENT_PROGRESS";
export const ADD_USER_MANAGEMENT_SUCCESS = "ADD_USER_MANAGEMENT_SUCCESS";
export const ADD_USER_MANAGEMENT_FAILURE = "ADD_USER_MANAGEMENT_FAILURE";

export const EDIT_DELETE_USER_MANAGEMENT_PROGRESS = "EDIT_DELETE_USER_MANAGEMENT_PROGRESS";
export const EDIT_DELETE_USER_MANAGEMENT_SUCCESS = "EDIT_DELETE_USER_MANAGEMENT_SUCCESS";
export const EDIT_DELETE_USER_MANAGEMENT_FAILURE = "EDIT_DELETE_USER_MANAGEMENT_FAILURE";


// ========================= Purchase ============================

export const GET_PURCHASE_INVOICE_LIST_PROGRESS = "GET_PURCHASE_INVOICE_LIST_PROGRESS";
export const GET_PURCHASE_INVOICE_LIST_SUCCESS = "GET_PURCHASE_INVOICE_LIST_SUCCESS";
export const GET_PURCHASE_INVOICE_LIST_FAILURE = "GET_PURCHASE_INVOICE_LIST_FAILURE";

export const ADD_PURCHASE_INVOICE_PROGRESS = "ADD_PURCHASE_INVOICE_PROGRESS";
export const ADD_PURCHASE_INVOICE_SUCCESS = "ADD_PURCHASE_INVOICE_SUCCESS";
export const ADD_PURCHASE_INVOICE_FAILURE = "ADD_PURCHASE_INVOICE_FAILURE";

export const EDIT_DELETE_PURCHASE_INVOICE_PROGRESS = "EDIT_DELETE_PURCHASE_INVOICE_PROGRESS";
export const EDIT_DELETE_PURCHASE_INVOICE_SUCCESS = "EDIT_DELETE_PURCHASE_INVOICE_SUCCESS";
export const EDIT_DELETE_PURCHASE_INVOICE_FAILURE = "EDIT_DELETE_PURCHASE_INVOICE_FAILURE";

export const GET_PURCHASE_ORDER_LIST_PROGRESS = "GET_PURCHASE_ORDER_LIST_PROGRESS";
export const GET_PURCHASE_ORDER_LIST_SUCCESS = "GET_PURCHASE_ORDER_LIST_SUCCESS";
export const GET_PURCHASE_ORDER_LIST_FAILURE = "GET_PURCHASE_ORDER_LIST_FAILURE";

export const ADD_PURCHASE_ORDER_PROGRESS = "ADD_PURCHASE_ORDER_PROGRESS";
export const ADD_PURCHASE_ORDER_SUCCESS = "ADD_PURCHASE_ORDER_SUCCESS";
export const ADD_PURCHASE_ORDER_FAILURE = "ADD_PURCHASE_ORDER_FAILURE";

export const EDIT_DELETE_PURCHASE_ORDER_PROGRESS = "EDIT_DELETE_PURCHASE_ORDER_PROGRESS";
export const EDIT_DELETE_PURCHASE_ORDER_SUCCESS = "EDIT_DELETE_PURCHASE_ORDER_SUCCESS";
export const EDIT_DELETE_PURCHASE_ORDER_FAILURE = "EDIT_DELETE_PURCHASE_ORDER_FAILURE";

export const GET_PURCHASE_RETURN_LIST_PROGRESS = "GET_PURCHASE_RETURN_LIST_PROGRESS";
export const GET_PURCHASE_RETURN_LIST_SUCCESS = "GET_PURCHASE_RETURN_LIST_SUCCESS";
export const GET_PURCHASE_RETURN_LIST_FAILURE = "GET_PURCHASE_RETURN_LIST_FAILURE";

export const ADD_PURCHASE_RETURN_PROGRESS = "ADD_PURCHASE_RETURN_PROGRESS";
export const ADD_PURCHASE_RETURN_SUCCESS = "ADD_PURCHASE_RETURN_SUCCESS";
export const ADD_PURCHASE_RETURN_FAILURE = "ADD_PURCHASE_RETURN_FAILURE";

export const EDIT_DELETE_PURCHASE_RETURN_PROGRESS = "EDIT_DELETE_PURCHASE_RETURN_PROGRESS";
export const EDIT_DELETE_PURCHASE_RETURN_SUCCESS = "EDIT_DELETE_PURCHASE_RETURN_SUCCESS";
export const EDIT_DELETE_PURCHASE_RETURN_FAILURE = "EDIT_DELETE_PURCHASE_RETURN_FAILURE";


// ========================= Sales ============================

export const GET_DELIVERY_CHALLAN_LIST_PROGRESS = "GET_DELIVERY_CHALLAN_LIST_PROGRESS";
export const GET_DELIVERY_CHALLAN_LIST_SUCCESS = "GET_DELIVERY_CHALLAN_LIST_SUCCESS";
export const GET_DELIVERY_CHALLAN_LIST_FAILURE = "GET_DELIVERY_CHALLAN_LIST_FAILURE";

export const ADD_DELIVERY_CHALLAN_PROGRESS = "ADD_DELIVERY_CHALLAN_PROGRESS";
export const ADD_DELIVERY_CHALLAN_SUCCESS = "ADD_DELIVERY_CHALLAN_SUCCESS";
export const ADD_DELIVERY_CHALLAN_FAILURE = "ADD_DELIVERY_CHALLAN_FAILURE";

export const EDIT_DELETE_DELIVERY_CHALLAN_PROGRESS = "EDIT_DELETE_DELIVERY_CHALLAN_PROGRESS";
export const EDIT_DELETE_DELIVERY_CHALLAN_SUCCESS = "EDIT_DELETE_DELIVERY_CHALLAN_SUCCESS";
export const EDIT_DELETE_DELIVERY_CHALLAN_FAILURE = "EDIT_DELETE_DELIVERY_CHALLAN_FAILURE";

export const GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS = "GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS";
export const GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS = "GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS";
export const GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE = "GET_DELIVERY_CHALLAN_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE";

export const GET_PROFORMA_INVOICE_LIST_PROGRESS = "GET_PROFORMA_INVOICE_LIST_PROGRESS";
export const GET_PROFORMA_INVOICE_LIST_SUCCESS = "GET_PROFORMA_INVOICE_LIST_SUCCESS";
export const GET_PROFORMA_INVOICE_LIST_FAILURE = "GET_PROFORMA_INVOICE_LIST_FAILURE";

export const ADD_PROFORMA_INVOICE_PROGRESS = "ADD_PROFORMA_INVOICE_PROGRESS";
export const ADD_PROFORMA_INVOICE_SUCCESS = "ADD_PROFORMA_INVOICE_SUCCESS";
export const ADD_PROFORMA_INVOICE_FAILURE = "ADD_PROFORMA_INVOICE_FAILURE";

export const EDIT_DELETE_PROFORMA_INVOICE_PROGRESS = "EDIT_DELETE_PROFORMA_INVOICE_PROGRESS";
export const EDIT_DELETE_PROFORMA_INVOICE_SUCCESS = "EDIT_DELETE_PROFORMA_INVOICE_SUCCESS";
export const EDIT_DELETE_PROFORMA_INVOICE_FAILURE = "EDIT_DELETE_PROFORMA_INVOICE_FAILURE";

export const GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS = "GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS";
export const GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS = "GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS";
export const GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE = "GET_PROFORMA_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE";


export const GET_QUOTATION_LIST_PROGRESS = "GET_QUOTATION_LIST_PROGRESS";
export const GET_QUOTATION_LIST_SUCCESS = "GET_QUOTATION_LIST_SUCCESS";
export const GET_QUOTATION_LIST_FAILURE = "GET_QUOTATION_LIST_FAILURE";

export const ADD_QUOTATION_PROGRESS = "ADD_QUOTATION_PROGRESS";
export const ADD_QUOTATION_SUCCESS = "ADD_QUOTATION_SUCCESS";
export const ADD_QUOTATION_FAILURE = "ADD_QUOTATION_FAILURE";

export const EDIT_DELETE_QUOTATION_PROGRESS = "EDIT_DELETE_QUOTATION_PROGRESS";
export const EDIT_DELETE_QUOTATION_SUCCESS = "EDIT_DELETE_QUOTATION_SUCCESS";
export const EDIT_DELETE_QUOTATION_FAILURE = "EDIT_DELETE_QUOTATION_FAILURE";

export const GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS = "GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS";
export const GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS = "GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS";
export const GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE = "GET_QUOTATION_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE";


export const GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_PROGRESS = "GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_PROGRESS";
export const GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_SUCCESS = "GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_SUCCESS";
export const GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_FAILURE = "GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_FAILURE";

export const ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_PROGRESS = "ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_PROGRESS";
export const ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_SUCCESS = "ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_SUCCESS";
export const ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_FAILURE = "ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_FAILURE";

export const EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_PROGRESS = "EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_PROGRESS";
export const EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_SUCCESS = "EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_SUCCESS";
export const EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_FAILURE = "EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_FAILURE";

export const GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_PROGRESS = "GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_PROGRESS";
export const GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_SUCCESS = "GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_SUCCESS";
export const GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_FAILURE = "GET_CUSTOMER_SUPPLIER_PAYMENT_LIST_FAILURE";

export const ADD_CUSTOMER_SUPPLIER_PAYMENT_PROGRESS = "ADD_CUSTOMER_SUPPLIER_PAYMENT_PROGRESS";
export const ADD_CUSTOMER_SUPPLIER_PAYMENT_SUCCESS = "ADD_CUSTOMER_SUPPLIER_PAYMENT_SUCCESS";
export const ADD_CUSTOMER_SUPPLIER_PAYMENT_FAILURE = "ADD_CUSTOMER_SUPPLIER_PAYMENT_FAILURE";

export const EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_PROGRESS = "EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_PROGRESS";
export const EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_SUCCESS = "EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_SUCCESS";
export const EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_FAILURE = "EDIT_DELETE_CUSTOMER_SUPPLIER_PAYMENT_FAILURE";

export const GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_PROGRESS = "GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_PROGRESS";
export const GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_SUCCESS = "GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_SUCCESS";
export const GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_FAILURE = "GET_CUSTOMER_SUPPLIER_PENDING_PAYMENT_LIST_FAILURE";

export const UPLOAD_FILE_ATTACHMENT_PROGRESS = "UPLOAD_FILE_ATTACHMENT_PROGRESS";
export const UPLOAD_FILE_ATTACHMENT_SUCCESS = "UPLOAD_FILE_ATTACHMENT_SUCCESS";
export const UPLOAD_FILE_ATTACHMENT_FAILURE = "UPLOAD_FILE_ATTACHMENT_FAILURE";

export const GET_PAYMENT_INVOICE_DEDUCTION_LIST_PROGRESS = "GET_PAYMENT_INVOICE_DEDUCTION_LIST_PROGRESS";
export const GET_PAYMENT_INVOICE_DEDUCTION_LIST_SUCCESS = "GET_PAYMENT_INVOICE_DEDUCTION_LIST_SUCCESS";
export const GET_PAYMENT_INVOICE_DEDUCTION_LIST_FAILURE = "GET_PAYMENT_INVOICE_DEDUCTION_LIST_FAILURE";

export const ADD_PAYMENT_INVOICE_DEDUCTION_PROGRESS = "ADD_PAYMENT_INVOICE_DEDUCTION_PROGRESS";
export const ADD_PAYMENT_INVOICE_DEDUCTION_SUCCESS = "ADD_PAYMENT_INVOICE_DEDUCTION_SUCCESS";
export const ADD_PAYMENT_INVOICE_DEDUCTION_FAILURE = "ADD_PAYMENT_INVOICE_DEDUCTION_FAILURE";

export const EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_PROGRESS = "EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_PROGRESS";
export const EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_SUCCESS = "EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_SUCCESS";
export const EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_FAILURE = "EDIT_DELETE_PAYMENT_INVOICE_DEDUCTION_FAILURE";

export const GET_SALE_INVOICE_LIST_PROGRESS = "GET_SALE_INVOICE_LIST_PROGRESS";
export const GET_SALE_INVOICE_LIST_SUCCESS = "GET_SALE_INVOICE_LIST_SUCCESS";
export const GET_SALE_INVOICE_LIST_FAILURE = "GET_SALE_INVOICE_LIST_FAILURE";

export const ADD_SALE_INVOICE_PROGRESS = "ADD_SALE_INVOICE_PROGRESS";
export const ADD_SALE_INVOICE_SUCCESS = "ADD_SALE_INVOICE_SUCCESS";
export const ADD_SALE_INVOICE_FAILURE = "ADD_SALE_INVOICE_FAILURE";

export const EDIT_DELETE_SALE_INVOICE_PROGRESS = "EDIT_DELETE_SALE_INVOICE_PROGRESS";
export const EDIT_DELETE_SALE_INVOICE_SUCCESS = "EDIT_DELETE_SALE_INVOICE_SUCCESS";
export const EDIT_DELETE_SALE_INVOICE_FAILURE = "EDIT_DELETE_SALE_INVOICE_FAILURE";

export const GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS = "GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS";
export const GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS = "GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS";
export const GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE = "GET_SALES_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE";

export const GET_AGE_OF_UNPAID_INVOICE_PROGRESS = "GET_AGE_OF_UNPAID_INVOICE_PROGRESS";
export const GET_AGE_OF_UNPAID_INVOICE_SUCCESS = "GET_AGE_OF_UNPAID_INVOICE_SUCCESS";
export const GET_AGE_OF_UNPAID_INVOICE_FAILURE = "GET_AGE_OF_UNPAID_INVOICE_FAILURE";

export const GET_SALES_ORDER_LIST_PROGRESS = "GET_SALES_ORDER_LIST_PROGRESS";
export const GET_SALES_ORDER_LIST_SUCCESS = "GET_SALES_ORDER_LIST_SUCCESS";
export const GET_SALES_ORDER_LIST_FAILURE = "GET_SALES_ORDER_LIST_FAILURE";

export const ADD_SALES_ORDER_PROGRESS = "ADD_SALES_ORDER_PROGRESS";
export const ADD_SALES_ORDER_SUCCESS = "ADD_SALES_ORDER_SUCCESS";
export const ADD_SALES_ORDER_FAILURE = "ADD_SALES_ORDER_FAILURE";

export const EDIT_DELETE_SALES_ORDER_PROGRESS = "EDIT_DELETE_SALES_ORDER_PROGRESS";
export const EDIT_DELETE_SALES_ORDER_SUCCESS = "EDIT_DELETE_SALES_ORDER_SUCCESS";
export const EDIT_DELETE_SALES_ORDER_FAILURE = "EDIT_DELETE_SALES_ORDER_FAILURE";

export const GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS = "GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_PROGRESS";
export const GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS = "GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_SUCCESS";
export const GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE = "GET_SALES_ORDER_ITEM_DESCRIPTION_FOR_MANUAL_ENTRY_FAILURE";

export const GET_SALES_RETURN_LIST_PROGRESS = "GET_SALES_RETURN_LIST_PROGRESS";
export const GET_SALES_RETURN_LIST_SUCCESS = "GET_SALES_RETURN_LIST_SUCCESS";
export const GET_SALES_RETURN_LIST_FAILURE = "GET_SALES_RETURN_LIST_FAILURE";

export const ADD_SALES_RETURN_PROGRESS = "ADD_SALES_RETURN_PROGRESS";
export const ADD_SALES_RETURN_SUCCESS = "ADD_SALES_RETURN_SUCCESS";
export const ADD_SALES_RETURN_FAILURE = "ADD_SALES_RETURN_FAILURE";

export const EDIT_DELETE_SALES_RETURN_PROGRESS = "EDIT_DELETE_SALES_RETURN_PROGRESS";
export const EDIT_DELETE_SALES_RETURN_SUCCESS = "EDIT_DELETE_SALES_RETURN_SUCCESS";
export const EDIT_DELETE_SALES_RETURN_FAILURE = "EDIT_DELETE_SALES_RETURN_FAILURE";

export const GET_MAIL_SETUP_LIST_PROGRESS = "GET_MAIL_SETUP_LIST_PROGRESS";
export const GET_MAIL_SETUP_LIST_SUCCESS = "GET_MAIL_SETUP_LIST_SUCCESS";
export const GET_MAIL_SETUP_LIST_FAILURE = "GET_MAIL_SETUP_LIST_FAILURE";

export const ADD_MAIL_SETUP_PROGRESS = "ADD_MAIL_SETUP_PROGRESS";
export const ADD_MAIL_SETUP_SUCCESS = "ADD_MAIL_SETUP_SUCCESS";
export const ADD_MAIL_SETUP_FAILURE = "ADD_MAIL_SETUP_FAILURE";

export const EDIT_DELETE_MAIL_SETUP_PROGRESS = "EDIT_DELETE_MAIL_SETUP_PROGRESS";
export const EDIT_DELETE_MAIL_SETUP_SUCCESS = "EDIT_DELETE_MAIL_SETUP_SUCCESS";
export const EDIT_DELETE_MAIL_SETUP_FAILURE = "EDIT_DELETE_MAIL_SETUP_FAILURE";

export const GET_PRINT_SETUP_LIST_PROGRESS = "GET_PRINT_SETUP_LIST_PROGRESS";
export const GET_PRINT_SETUP_LIST_SUCCESS = "GET_PRINT_SETUP_LIST_SUCCESS";
export const GET_PRINT_SETUP_LIST_FAILURE = "GET_PRINT_SETUP_LIST_FAILURE";

export const ADD_PRINT_SETUP_PROGRESS = "ADD_PRINT_SETUP_PROGRESS";
export const ADD_PRINT_SETUP_SUCCESS = "ADD_PRINT_SETUP_SUCCESS";
export const ADD_PRINT_SETUP_FAILURE = "ADD_PRINT_SETUP_FAILURE";

export const EDIT_DELETE_PRINT_SETUP_PROGRESS = "EDIT_DELETE_PRINT_SETUP_PROGRESS";
export const EDIT_DELETE_PRINT_SETUP_SUCCESS = "EDIT_DELETE_PRINT_SETUP_SUCCESS";
export const EDIT_DELETE_PRINT_SETUP_FAILURE = "EDIT_DELETE_PRINT_SETUP_FAILURE";

export const WATERMARK_PRINT_SETUP_PROGRESS = "WATERMARK_PRINT_SETUP_PROGRESS";
export const WATERMARK_PRINT_SETUP_SUCCESS = "WATERMARK_PRINT_SETUP_SUCCESS";
export const WATERMARK_PRINT_SETUP_FAILURE = "WATERMARK_PRINT_SETUP_FAILURE";

export const FOOTER_PRINT_SETUP_PROGRESS = "FOOTER_PRINT_SETUP_PROGRESS";
export const FOOTER_PRINT_SETUP_SUCCESS = "FOOTER_PRINT_SETUP_SUCCESS";
export const FOOTER_PRINT_SETUP_FAILURE = "FOOTER_PRINT_SETUP_FAILURE";

export const SIGNATURE_PRINT_SETUP_PROGRESS = "SIGNATURE_PRINT_SETUP_PROGRESS";
export const SIGNATURE_PRINT_SETUP_SUCCESS = "SIGNATURE_PRINT_SETUP_SUCCESS";
export const SIGNATURE_PRINT_SETUP_FAILURE = "SIGNATURE_PRINT_SETUP_FAILURE";

// =============Reports ============

export const GET_SALES_REGISTER_REPORT_PROGRESS = "GET_SALES_REGISTER_REPORT_PROGRESS";
export const GET_SALES_REGISTER_REPORT_SUCCESS = "GET_SALES_REGISTER_REPORT_SUCCESS";
export const GET_SALES_REGISTER_REPORT_FAILURE = "GET_SALES_REGISTER_REPORT_FAILURE";

export const GET_PURCHASE_REGISTER_REPORT_PROGRESS = "GET_PURCHASE_REGISTER_REPORT_PROGRESS";
export const GET_PURCHASE_REGISTER_REPORT_SUCCESS = "GET_PURCHASE_REGISTER_REPORT_SUCCESS";
export const GET_PURCHASE_REGISTER_REPORT_FAILURE = "GET_PURCHASE_REGISTER_REPORT_FAILURE";

export const GET_SALES_ORDER_HISTORY_REPORT_PROGRESS = "GET_SALES_ORDER_HISTORY_REPORT_PROGRESS";
export const GET_SALES_ORDER_HISTORY_REPORT_SUCCESS = "GET_SALES_ORDER_HISTORY_REPORT_SUCCESS";
export const GET_SALES_ORDER_HISTORY_REPORT_FAILURE = "GET_SALES_ORDER_HISTORY_REPORT_FAILURE";

export const GET_PURCHASE_ORDER_HISTORY_REPORT_PROGRESS = "GET_PURCHASE_ORDER_HISTORY_REPORT_PROGRESS";
export const GET_PURCHASE_ORDER_HISTORY_REPORT_SUCCESS = "GET_PURCHASE_ORDER_HISTORY_REPORT_SUCCESS";
export const GET_PURCHASE_ORDER_HISTORY_REPORT_FAILURE = "GET_PURCHASE_ORDER_HISTORY_REPORT_FAILURE";

export const GET_ACCOUNT_STATEMENT_REPORT_PROGRESS = "GET_ACCOUNT_STATEMENT_REPORT_PROGRESS";
export const GET_ACCOUNT_STATEMENT_REPORT_SUCCESS = "GET_ACCOUNT_STATEMENT_REPORT_SUCCESS";
export const GET_ACCOUNT_STATEMENT_REPORT_FAILURE = "GET_ACCOUNT_STATEMENT_REPORT_FAILURE";

export const GET_PAYMENT_REGISTER_REPORT_PROGRESS = "GET_PAYMENT_REGISTER_REPORT_PROGRESS";
export const GET_PAYMENT_REGISTER_REPORT_SUCCESS = "GET_PAYMENT_REGISTER_REPORT_SUCCESS";
export const GET_PAYMENT_REGISTER_REPORT_FAILURE = "GET_PAYMENT_REGISTER_REPORT_FAILURE";

export const GET_OUTSTANDING_REPORT_PROGRESS = "GET_OUTSTANDING_REPORT_PROGRESS";
export const GET_OUTSTANDING_REPORT_SUCCESS = "GET_OUTSTANDING_REPORT_SUCCESS";
export const GET_OUTSTANDING_REPORT_FAILURE = "GET_OUTSTANDING_REPORT_FAILURE";

export const GET_GST_REGESTER_REPORT_PROGRESS = "GET_GST_REGESTER_REPORT_PROGRESS";
export const GET_GST_REGESTER_REPORT_SUCCESS = "GET_GST_REGESTER_REPORT_SUCCESS";
export const GET_GST_REGESTER_REPORT_FAILURE = "GET_GST_REGESTER_REPORT_FAILURE";
// Upload excel 
export const UPLOAD_BANK_EXCEL_PROGRESS = "UPLOAD_BANK_EXCEL_PROGRESS";
export const UPLOAD_BANK_EXCEL_SUCCESS = "UPLOAD_BANK_EXCEL_SUCCESS";
export const UPLOAD_BANK_EXCEL_FAILURE = "UPLOAD_BANK_EXCEL_FAILURE";

export const UPLOAD_CNS_EXCEL_PROGRESS = "UPLOAD_CNS_EXCEL_PROGRESS";
export const UPLOAD_CNS_EXCEL_SUCCESS = "UPLOAD_CNS_EXCEL_SUCCESS";
export const UPLOAD_CNS_EXCEL_FAILURE = "UPLOAD_CNS_EXCEL_FAILURE";

export const UPLOAD_ITEMS_EXCEL_PROGRESS = "UPLOAD_ITEMS_EXCEL_PROGRESS";
export const UPLOAD_ITEMS_EXCEL_SUCCESS = "UPLOAD_ITEMS_EXCEL_SUCCESS";
export const UPLOAD_ITEMS_EXCEL_FAILURE = "UPLOAD_ITEMS_EXCEL_FAILURE";

export const UPLOAD_USER_EXCEL_PROGRESS = "UPLOAD_USER_EXCEL_PROGRESS";
export const UPLOAD_USER_EXCEL_SUCCESS = "UPLOAD_USER_EXCEL_SUCCESS";
export const UPLOAD_USER_EXCEL_FAILURE = "UPLOAD_USER_EXCEL_FAILURE";

export const GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_PROGRESS = "GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_PROGRESS";
export const GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_SUCCESS = "GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_SUCCESS";
export const GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_FAILURE = "GET_TOTAL_RECEIVABLE_PAYBLE_DASHBOARD_FAILURE";

export const GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_PROGRESS = "GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_PROGRESS";
export const GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_SUCCESS = "GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_SUCCESS";
export const GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_FAILURE = "GET_MONTH_AND_CUSTOMER_WISE_SALES_DASHBOARD_FAILURE";

export const GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_PROGRESS = "GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_PROGRESS";
export const GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_SUCCESS = "GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_SUCCESS";
export const GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_FAILURE = "GET_MONTH_AND_CUSTOMER_WISE_PURCHASE_DASHBOARD_FAILURE";

// ========================= Production ============================

export const GET_PRODUCTION_LIST_PROGRESS = "GET_PRODUCTION_LIST_PROGRESS";
export const GET_PRODUCTION_LIST_SUCCESS = "GET_PRODUCTION_LIST_SUCCESS";
export const GET_PRODUCTION_LIST_FAILURE = "GET_PRODUCTION_LIST_FAILURE";

export const ADD_PRODUCTION_PROGRESS = "ADD_PRODUCTION_PROGRESS";
export const ADD_PRODUCTION_SUCCESS = "ADD_PRODUCTION_SUCCESS";
export const ADD_PRODUCTION_FAILURE = "ADD_PRODUCTION_FAILURE";

export const EDIT_DELETE_PRODUCTION_PROGRESS = "EDIT_DELETE_PRODUCTION_PROGRESS";
export const EDIT_DELETE_PRODUCTION_SUCCESS = "EDIT_DELETE_PRODUCTION_SUCCESS";
export const EDIT_DELETE_PRODUCTION_FAILURE = "EDIT_DELETE_PRODUCTION_FAILURE";

export const MAIL_SEND_ATTACHMENT_PROGRESS = "MAIL_SEND_ATTACHMENT_PROGRESS";
export const MAIL_SEND_ATTACHMENT_SUCCESS = "MAIL_SEND_ATTACHMENT_SUCCESS";
export const MAIL_SEND_ATTACHMENT_FAILURE = "MAIL_SEND_ATTACHMENT_FAILURE";

export const GET_NOTIFICATIONS_PROGRESS = "GET_NOTIFICATIONS_PROGRESS";
export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS";
export const GET_NOTIFICATIONS_FAILURE = "GET_NOTIFICATIONS_FAILURE";